"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DCAutoApi = void 0;
const trade_utils_lib_1 = require("trade_utils_lib");
class DCAutoApiClass {
    constructor(apiKey) {
        this.apiKey = apiKey;
    }
    getRequest(url, params) {
        const token = {
            market: this.apiKey.exchange,
            cloudKeyId: this.apiKey.key_id,
        };
        return trade_utils_lib_1.ObservableUtils.getWithAccessAndSpotAuth(url, token, params);
    }
    postRequest(url, params) {
        const token = {
            market: this.apiKey.exchange,
            cloudKeyId: this.apiKey.key_id,
        };
        return trade_utils_lib_1.ObservableUtils.postWithAccessAndSpotAuth(url, token, params);
    }
    deleteRequest(url, params) {
        const token = {
            market: this.apiKey.exchange,
            cloudKeyId: this.apiKey.key_id,
        };
        return trade_utils_lib_1.ObservableUtils.deleteWithAccessAndSpotAuth(url, token, params);
    }
    /**
     * 配置项
     */
    config() {
        const url = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().FM_HOST + "/dual_auto/conf/";
        return this.postRequest(url);
    }
    /**
     * 申购
     */
    invest(params) {
        const url = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().FM_HOST + "/dual_auto/invest/";
        return this.postRequest(url, params);
    }
    /**
     * 加减仓
     */
    transfer(params) {
        const url = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().FM_HOST + "/dual_auto/invest/transfer/";
        return this.postRequest(url, params);
    }
    /**
     * 修改参数
     */
    modifyParams(params) {
        const url = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().FM_HOST + "/dual_auto/invest/modify_conf/";
        return this.postRequest(url, params);
    }
    /**
     * 取消加减仓
     */
    cancelTransfer(bu_order_id, bu_order_type) {
        const url = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().FM_HOST + "/dual_auto/invest/transfer/cancel/";
        return this.postRequest(url, {
            bu_order_id: bu_order_id,
            bu_order_type: bu_order_type,
        });
    }
    /**
     * 解除锁仓
     */
    release(bu_order_id, bu_order_type) {
        const url = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().FM_HOST + "/dual_auto/invest/release/";
        return this.postRequest(url, {
            bu_order_id: bu_order_id,
            bu_order_type: bu_order_type,
        });
    }
    /**

     * 关单
     */
    close(bu_order_id, bu_order_type) {
        const url = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().FM_HOST + "/dual_auto/invest/close/";
        return this.postRequest(url, {
            bu_order_id: bu_order_id,
            bu_order_type: bu_order_type,
        });
    }
    /**
     * 取消关单
     */
    cancelClose(bu_order_id, bu_order_type) {
        const url = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().FM_HOST + "/dual_auto/invest/cancel_close/";
        return this.postRequest(url, {
            bu_order_id: bu_order_id,
            bu_order_type: bu_order_type,
        });
    }
    /**
     * 领取收益
     */
    collect(bu_order_id, bu_order_type) {
        const url = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().FM_HOST + "/dual_auto/invest/collect/";
        return this.postRequest(url, {
            bu_order_id: bu_order_id,
            bu_order_type: bu_order_type,
        });
    }
    /**
     * 运行中的订单记录
     */
    records(bu_order_type, page_token, limit = 20) {
        const url = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().FM_HOST + "/dual_auto/invest/records/";
        return this.getRequest(url, {
            bu_order_type: bu_order_type,
            limit: limit,
            page_token: page_token !== null && page_token !== void 0 ? page_token : null,
        });
    }
    /**
     * 单个订单查询
     */
    order(bu_order_id) {
        const url = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().FM_HOST + "/dual_auto/invest/";
        return this.getRequest(url, {
            bu_order_id: bu_order_id,
        });
    }
    /**
     * 历史订单记录
     */
    history(bu_order_type, page_token, limit = 20) {
        const url = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().FM_HOST + "/dual_auto/invest/history/";
        return this.getRequest(url, {
            bu_order_type: bu_order_type,
            limit: limit,
            page_token: page_token !== null && page_token !== void 0 ? page_token : null,
        });
    }
    /**
     * 订单流水
     */
    bills(bu_order_id, bu_order_type, page_token, limit = 20) {
        const url = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().FM_HOST + "/dual_auto/invest/bills/";
        return this.getRequest(url, {
            bu_order_id: bu_order_id,
            bu_order_type: bu_order_type,
            limit: limit,
            page_token: page_token !== null && page_token !== void 0 ? page_token : null,
        });
    }
    /**
     * 订单分享
     */
    shareOrder(bu_order_id, bu_order_type) {
        const url = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().FM_HOST + "/dual_auto/order/gene_share/";
        return this.postRequest(url, {
            bu_order_id: bu_order_id,
            bu_order_type: bu_order_type,
        });
    }
    /**
     * 获取分享订单信息
     */
    getShareOrder(order_share_id) {
        const url = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().FM_HOST + "/dual_auto/order/share/";
        return this.getRequest(url, {
            order_share_id: order_share_id,
        });
    }
    /**
     * 复投撤销订单
     */
    revokeOrder(bu_order_id, bu_order_type) {
        const url = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().FM_HOST + "/dual_auto/invest/revoke/";
        return this.postRequest(url, {
            bu_order_id: bu_order_id,
            bu_order_type: bu_order_type,
        });
    }
}
let apiInstance;
const DCAutoApi = (apiKey) => {
    if (apiInstance &&
        apiInstance.apiKey.alias === apiKey.alias &&
        apiInstance.apiKey.exchange === apiKey.exchange &&
        apiInstance.apiKey.key_id === apiKey.key_id) {
        return apiInstance;
    }
    else {
        apiInstance = new DCAutoApiClass(apiKey);
        return apiInstance;
    }
};
exports.DCAutoApi = DCAutoApi;
